export default "__VITE_ASSET__BOfdz5FW__"